import React, { useEffect, useState } from "react";
import { URLS } from "../../helpers/URLS";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import UnreadNotifications from "./UnreadNotifications";
import AllNotifications from "./AllNotifications";
import useAxios from "../../helpers/Hooks/useAxios";
import './Notifications.scss'
import { notificationIcon } from "../../helpers/notificationIcon";

function TabPanel(props) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ px: 2, py: 2 }}>
                    {/* component="div": a bare Typography renders a <p>, which
                        cannot legally hold the panel's block content */}
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const NotificationTab = ({ setOpenNotificationPanel, getValue, setNumber, defaultTab = 0 }) => {

    const { fetchData } = useAxios();

    const [value, setValue] = React.useState(defaultTab || 0);
    const [allNotifications, setAllNotifications] = useState([]);

    /* start true, so the empty state is never shown before the first
       response comes back */
    const [loading, setLoading] = useState(true);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        getAllNotifications();
    }, []);


    const getAllNotifications = async () => {
        setLoading(true);
        const response = await fetchData({ url: URLS.getMyNotifications, method: "get" });
        setLoading(false);
        if (response.status === 200) {
            const allNotices = response.data
            allNotices.forEach((notify) => {
                notify.icon = notificationIcon(notify?.notification?.title);
            })
            setAllNotifications(allNotices)
        }
    }

    return (
        <Box sx={{ width: '100%' }} >
            <Box>
                <Tabs value={value} onChange={handleChange} aria-label="Notification filters">
                    <Tab label="Unread" {...a11yProps(0)} />
                    <Tab label="All" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <UnreadNotifications loading={loading} getValue={getValue} setNumber={setNumber}
                    allNotifications={allNotifications}
                    setOpenNotificationPanel={setOpenNotificationPanel}
                    /* refetched after a clear, so the unread list, the All tab
                       and the header badge all settle from one response */
                    onCleared={getAllNotifications} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <AllNotifications loading={loading} allNotifications={allNotifications} setOpenNotificationPanel={setOpenNotificationPanel} />
            </TabPanel>
        </Box>
    )
}

export default NotificationTab